// extracted by css-extract-rspack-plugin
export default {"HighlightedText":"HighlightedText-module__HighlightedText__No12X"};